import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import About from './About';
import {ToastProvider} from "../common/Toast";
import { useRef } from 'react';

const Layout = () => {
  const headerRef = useRef();

  return (
    <div className="min-h-screen flex flex-col">
      <ToastProvider>
        <Header ref={headerRef} />
        <main className="flex-grow container mx-auto px-4 py-8 mb-6">
          <Outlet context={{ headerRef }} />
        </main>

        <About />
        <Footer />
      </ToastProvider>
    </div>
  );
};

export default Layout; 